import { startOfWeek, endOfWeek } from 'date-fns';

interface WeekRange {
  weekStart: string; // ISO string
  weekEnd: string;   // ISO string
}

/**
 * Returns the ISO-string boundaries of the week containing `date`.
 *
 * System convention: weeks start on Sunday (weekStartsOn = 0).
 * All schedule hooks, dashboard widgets, and cache keys rely on this
 * convention.  Pass a different value only when company settings
 * explicitly dictate another start day.
 */
export function getWeekRange(
  date: Date,
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0
): WeekRange {
  return {
    weekStart: startOfWeek(date, { weekStartsOn }).toISOString(),
    weekEnd: endOfWeek(date, { weekStartsOn }).toISOString(),
  };
}
